(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var App = /*#__PURE__*/function () {
  function App() {
    var _this = this;
    _classCallCheck(this, App);
    this.toggleMenus = document.querySelectorAll('.toggle-menu');
    this.menu = document.querySelector('#responsive-menu').classList;
    this.header = document.querySelector('header');
    if (!this.header.classList.contains('-home')) {
      var headerHeight = this.header.offsetHeight - 2;
      window.document.body.style.paddingTop = headerHeight + 'px';
    }
    window.addEventListener('scroll', function () {
      return _this.changeHeaderOnScroll();
    });
  }
  _createClass(App, [{
    key: "start",
    value: function start() {
      this.navigation();
      this.mediaVideo();
    }
  }, {
    key: "navigation",
    value: function navigation() {
      var _this2 = this;
      this.toggleMenus.forEach(function (toggler) {
        return toggler.addEventListener('click', function () {
          return _this2.menu.toggle('open');
        });
      });
    }
  }, {
    key: "mediaVideo",
    value: function mediaVideo() {
      var videos = document.querySelectorAll('.media-video');
      videos.forEach(function (v) {
        try {
          v.muted = true;
          v.load();
          v.play();
        } catch (e) {
          alert('Cannot play' + v.src + ': ' + e);
          v.controls = true;
        }
      });
    }
  }, {
    key: "changeHeaderOnScroll",
    value: function changeHeaderOnScroll() {
      if (!this.header) return;
      var headerHeight = this.header.offsetHeight;
      var headerBottomOffset = headerHeight / 2;
      var scroll = window.scrollY;
      var extraOffset = this.header.classList.contains('-home') ? 600 : 100;
      if (scroll > headerBottomOffset + extraOffset) {
        this.header.classList.add('scrolled');
      } else {
        this.header.classList.remove('scrolled');
      }
    }
  }]);
  return App;
}();
window.addEventListener('load', function () {
  var app = new App();
  app.start();
  var main = document.querySelector('main');
  var path = "/assets/js/".concat(main.id, ".min.js");
  var script = document.createElement('script');
  script.src = path;
  script.async = true;
  script.type = 'module';
  document.body.appendChild(script);
  script.onload = function (s) {
    console.log("Loaded ".concat(path));
  };
  script.onerror = function () {
    console.error("Error loading ".concat(path));
  };
});

},{}]},{},[1]);
